module.exports = __webpack_public_path__ + "static/pets-section-nest-e67d030d90c002f5f9e36415bea2b3ab.png";